// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copyright {\n  position: absolute;\n  left: 0;\n  bottom: 10px;\n  z-index: 9;\n  width: 100vw;\n}\n", ""]);
// Exports
module.exports = exports;
